export default {
  setAll(state, surveyGroups) {
    state.all = surveyGroups
  },
}
